import { isValidEmail } from '../utils/isValidEmail'

const form = document.getElementById('form-contact')

const formMessage = document.getElementById('form-contact-message')

const name = form.querySelector('#name')
const email = form.querySelector('#email')
const message = form.querySelector('#message')

export const FormContact = {
	checkInputs: (event) => {
		const usernameValue = name.value
		const emailValue = email.value
		const messageValue = message.value
		
		if(usernameValue.length <= 0) {
			FormContact.setErrorFor(name)
		} else {
			FormContact.setSuccessFor(name)
		} 

		if(emailValue.length <= 0 && !isValidEmail(email)) {
			FormContact.setErrorFor(email)
		} else {
			FormContact.setSuccessFor(email) 
		}

		if(messageValue.length <= 0) {
			FormContact.setErrorFor(message)
		} else {
			FormContact.setSuccessFor(message)
		}
		
	},
	setMessageFor: (state) => {
		if(!formMessage) return

		const isMessageShow = () => formMessage.classList.remove('hidden')
		const isMessageHidden = () => formMessage.classList.add('hidden')

		if(state === 'error') {
			formMessage.classList.add('bg-red-500')
			const getMessageError = formMessage.getAttribute('data-feedback-error')
			formMessage.innerText = getMessageError
			isMessageShow()
		}

		if(state === 'success') {
			formMessage.classList.add('bg-cian-500')
			const getMessageSuccess = formMessage.getAttribute('data-feedback-success')
			formMessage.innerText = getMessageSuccess
			isMessageShow()

			setInterval(() => {
				isMessageHidden()
				formMessage.classList.remove('bg-cian-500')
			}, 4000)
		}
	},
	setErrorFor: (input) => {
		const parentInput = input.parentElement 
		
		if(input) {
			parentInput.classList.add('is-error')
			FormContact.setMessageFor('error')

			return
		}

		if(input === null) target.classList.remove('is-error')
	},
	setSuccessFor: (input) => {
		const parentInput = input.parentElement 
		
		if(input) {
			parentInput.classList.contains('is-error') && parentInput.classList.remove('is-error')
			parentInput.classList.add('is-success')

			return
		}

		if(input === null) parentInput.classList.remove('is-success')
	},
	submitButtonHandler: (form) => {
		form.addEventListener("submit", (event) => {
			event.preventDefault()
			FormContact.checkInputs(event)

			const { target } = event
			const { action, method } = target

			body = new FormData(target)

			fetch(action, {
				method,
				body
			}).then(response => {
				if(!response.url.includes('error=field')) {
					FormContact.setMessageFor('success')
					FormContact.reset()
				}
			})
		})
	},
	reset: () => {
		form.reset()

		const formControls = document.querySelectorAll('.form-control')
		
		formControls.forEach(formControl => formControl.classList.remove('is-success'))
		
	},
	init: () => {
		if(!form) return

		FormContact.submitButtonHandler(form)
	}
}